module.exports = __webpack_public_path__ + "static/media/bg-image-54.efdc4e1a.jpg";